/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftOccupiedInterval } from "../../entities/models/ShiftOccupiedInterval";
import { z } from "zod/v4";

export const modelsShiftOccupiedIntervalSchema = z.object({
    "end_time": z.optional(z.string()),
"shift_id": z.optional(z.string()),
"start_time": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsShiftOccupiedInterval>